import TemplateView from '../components/templates/BsTemplateView.vue'
import Login from '../components/templates/BsLoginView.vue'
import Logout from '../components/templates/BsLogoutView.vue'
import Error from '../components/templates/BsErrorView.vue'
import CircuitChk from '../components/templates/BsCircuitChkView.vue'

// import PagesList from '../components/templates/BsDataListView.vue'
import DashBoard from '../components/templates/BsDashBoardView.vue'

import MemberList from '../components/templates/Member/ListView.vue'
import MemberData from '../components/templates/Member/DataView.vue'
import MemberPhotoChk from '../components/templates/Member/PhotoChkView.vue'

import EventList from '../components/templates/EventMain/ListView.vue'
import EventData from '../components/templates/EventMain/DataView.vue'

import MigrationList from '../components/templates/Migration/ListView.vue'
import MigrationData from '../components/templates/Migration/DataView.vue'

import ApplicationList from '../components/templates/Application/ListView.vue'
import ApplicationData from '../components/templates/Application/DataView.vue'
import OwnerApplicationList from '../components/templates/OwnerApplication/ListView.vue'
import OwnerApplicationData from '../components/templates/OwnerApplication/DataView.vue'
import ClubApplicationList from '../components/templates/ClubApplication/ListView.vue'
import ClubApplicationData from '../components/templates/ClubApplication/DataView.vue'

import PromotionList from '../components/templates/Promotion/ListView.vue'
import PromotionData from '../components/templates/Promotion/DataView.vue'
import PromotionRanking from '../components/templates/Promotion/RankingView.vue'

import PromotionCondList from '../components/templates/PromotionCond/ListView.vue'
import PromotionCondData from '../components/templates/PromotionCond/DataView.vue'

import ArticleCategoryList from '../components/templates/ArticleCategory/ListView.vue'
import ArticleCategoryData from '../components/templates/ArticleCategory/DataView.vue'
import ArticleList from '../components/templates/Article/ListView.vue'
import ArticleData from '../components/templates/Article/DataView.vue'

import InformationList from '../components/templates/Information/ListView.vue'
import InformationData from '../components/templates/Information/DataView.vue'

import PointBlockList from '../components/templates/PointBlock/ListView.vue'
import PointBlockData from '../components/templates/PointBlock/DataView.vue'
import AreaRegionList from '../components/templates/AreaRegion/ListView.vue'
import AreaRegionData from '../components/templates/AreaRegion/DataView.vue'
import AreaPrefList from '../components/templates/AreaPref/ListView.vue'
import AreaPrefData from '../components/templates/AreaPref/DataView.vue'
import AreaDistrictList from '../components/templates/AreaDistrict/ListView.vue'
import AreaDistrictData from '../components/templates/AreaDistrict/DataView.vue'
import CircuitList from '../components/templates/Circuit/ListView.vue'
import CircuitData from '../components/templates/Circuit/DataView.vue'

import EventCdList from '../components/templates/EventCd/ListView.vue'
import EventCdData from '../components/templates/EventCd/DataView.vue'
import LicenseEventCdList from '../components/templates/LicenseEventCd/ListView.vue'
import LicenseEventCdData from '../components/templates/LicenseEventCd/DataView.vue'
import LicenseCdList from '../components/templates/LicenseCd/ListView.vue'
import LicenseCdData from '../components/templates/LicenseCd/DataView.vue'
import LicenseTypeList from '../components/templates/LicenseType/ListView.vue'
import LicenseTypeData from '../components/templates/LicenseType/DataView.vue'

import InsuranceList from '../components/templates/Insurance/ListView.vue'
import LicensePromotionData from '../components/templates/LicenseCd/PromotionView.vue'

import RaceOwnerTypeCdList from '../components/templates/RaceOwnerTypeCd/ListView.vue'
import RaceOwnerTypeCdData from '../components/templates/RaceOwnerTypeCd/DataView.vue'

import ClubList from '../components/templates/Club/ListView.vue'
import ClubData from '../components/templates/Club/DataView.vue'
import OwnerList from '../components/templates/Owner/ListView.vue'
import OwnerData from '../components/templates/Owner/DataView.vue'

import OwnerEntryList from '../components/templates/SystemEntry/ListView.vue'
import OwnerEntryData from '../components/templates/SystemEntry/DataView.vue'

import StaffList from '../components/templates/Staff/ListView.vue'
import StaffData from '../components/templates/Staff/DataView.vue'

import ManageList from '../components/templates/Manage/ListView.vue'
import ManageData from '../components/templates/Manage/DataView.vue'
import ManageManual from '../components/templates/Manage/ManualView.vue'

import ManageRoleList from '../components/templates/ManageRole/ListView.vue'
import ManageRoleData from '../components/templates/ManageRole/DataView.vue'

import SalesErrorCheck from '../components/templates/Sales/ErrorCheck.vue'
import SalesJournal from '../components/templates/Sales/JournalView.vue'
import SalesCsvExportView from '../components/templates/Sales/CsvExportView.vue'
import SalesDataList from '../components/templates/Sales/SalesDataListView.vue'

import RaceSeriesList from '../components/templates/RaceSeries/ListView.vue'
import RaceSeriesData from '../components/templates/RaceSeries/DataView.vue'

import RaceClassList from '../components/templates/RaceClass/ListView.vue'
import RaceClassData from '../components/templates/RaceClass/DataView.vue'

import RaceTypeList from '../components/templates/RaceType/ListView.vue'
import RaceTypeData from '../components/templates/RaceType/DataView.vue'

import EnquateSheetList from '../components/templates/Enquate/ListView.vue'
import EnquateSheetData from '../components/templates/Enquate/DataView.vue'

// import for PaymentSetting
import PaymentSettingList from '../components/templates/PaymentSetting/ListView.vue'
import PaymentSettingData from '../components/templates/PaymentSetting/DataView.vue'

import GetPaymentLogView from '../components/templates/Sales/GetPaymentLog.vue'

import MasterList from '../components/templates/Master/ListView.vue'
import MasterEventData from '../components/templates/Master/Event/EventEditView.vue'
import MasterRaceTypeData from '../components/templates/Master/RaceType/RaceTypeEditView.vue'
import MasterEventRaceTypeData from '../components/templates/Master/EventRaceType/EventRaceTypeEditView.vue'
import MasterSportsYearData from '../components/templates/Master/SportsYear/SportsYearEditView.vue'
import MasterOwnerData from '../components/templates/Master/Owner/OwnerEditView.vue'
import MasterOwnerTypeData from '../components/templates/Master/OwnerType/OwnerTypeEditView.vue'
import MasterVenueData from '../components/templates/Master/Venue/VenueEditView.vue'
import MasterDistrictData from '../components/templates/Master/District/DistrictEditView.vue'
import MasterSeriesData from '../components/templates/Master/Series/SeriesEditView.vue'
import MasterLicenseData from '../components/templates/Master/License/LicenseEditView.vue'
import MasterPointUnitData from '../components/templates/Master/PointUnit/PointUnitEditView.vue'
import MasterClassOwnerData from '../components/templates/Master/ClassOwner/ClassOwnerEditView.vue'
import MasterHallData from '../components/templates/Master/Hall/HallEditView.vue'
import MasterRaceSeriesData from '../components/templates/Master/RaceSeries/RaceSeriesEditView.vue'
import MasterDisplaceData from '../components/templates/Master/Displace/DisplaceEditView.vue'
import MasterRaceOwnerAccessData from '../components/templates/Master/RaceOwnerAccess/RaceOwnerAccessEditView.vue'
import MasterOwnerEventData from '../components/templates/Master/RaceOwnerEvent/RaceOwnerEventEditView.vue'

export default [
  {
    path: '/',
    name: 'base',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: DashBoard
      }
    ]
  },
  {
    path: '/master',
    name: 'master',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/master/list',
        name: 'master_list',
        component: MasterList
      },
      {
        path: 'event/:id',
        name: 'master_event_detail',
        component: MasterEventData
      },
      {
        path: 'race_type/:id',
        name: 'master_race_type_detail',
        component: MasterRaceTypeData
      },
      {
        path: 'event_race_type/:id',
        name: 'master_event_race_type_detail',
        component: MasterEventRaceTypeData
      },
      {
        path: 'sports_year/:id',
        name: 'master_sports_year_detail',
        component: MasterSportsYearData
      },
      {
        path: 'race_owner/:id',
        name: 'master_owner_detail',
        component: MasterOwnerData
      },
      {
        path: 'owner_type/:id',
        name: 'master_owner_type_detail',
        component: MasterOwnerTypeData
      },
      {
        path: 'race_owner_event/:id',
        name: 'master_race_owner_event_detail',
        component: MasterOwnerEventData
      },
      {
        path: 'venue/:id',
        name: 'master_venue_detail',
        component: MasterVenueData
      },
      {
        path: 'district/:id',
        name: 'master_district_detail',
        component: MasterDistrictData
      },
      {
        path: 'series/:id',
        name: 'master_series_detail',
        component: MasterSeriesData
      },
      {
        path: 'license/:id',
        name: 'master_license_detail',
        component: MasterLicenseData
      },
      {
        path: 'point_unit/:id',
        name: 'master_point_unit_detail',
        component: MasterPointUnitData
      },
      {
        path: 'class_owner/:id',
        name: 'master_class_owner_detail',
        component: MasterClassOwnerData
      },
      {
        path: 'hall/:id',
        name: 'master_hall_detail',
        component: MasterHallData
      },
      {
        path: 'race_series/:id',
        name: 'master_race_series_detail',
        component: MasterRaceSeriesData
      },
      {
        path: 'displace/:id',
        name: 'master_displace_detail',
        component: MasterDisplaceData
      },
      {
        path: 'race_owner_access/:id',
        name: 'master_race_owner_access_detail',
        component: MasterRaceOwnerAccessData
      }
    ]
  },
  {
    path: '/article_category',
    name: 'article_category',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/article_category/:id',
        name: 'article_category_detail',
        component: ArticleCategoryData
      },
      {
        path: '/article_category/list',
        name: 'article_category_list',
        component: ArticleCategoryList
      }
    ]
  },

  {
    path: '/enquate',
    name: 'enquate',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/enquate/:id',
        name: 'enquate_detail',
        component: EnquateSheetData
      },
      {
        path: '/enquate/list',
        name: 'enquate_list',
        component: EnquateSheetList
      }
    ]
  },

  {
    path: '/event',
    name: 'event',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/event/:id',
        name: 'event_detail',
        component: EventData
      },
      {
        path: '/event/list',
        name: 'event_list',
        component: EventList
      }
    ]
  },
  {
    path: '/article',
    name: 'article',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/article/:id',
        name: 'article_detail',
        component: ArticleData
      },
      {
        path: '/article/list',
        name: 'article_list',
        component: ArticleList
      }
    ]
  },
  {
    path: '/application',
    name: 'application',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/application/:id',
        name: 'application_detail',
        component: ApplicationData
      },
      {
        path: '/application/list',
        name: 'application_list',
        component: ApplicationList
      }
    ]
  },
  {
    path: '/owner_application',
    name: 'owner_application',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/owner_application/:id',
        name: 'owner_application_detail',
        component: OwnerApplicationData
      },
      {
        path: '/owner_application/list',
        name: 'owner_application_list',
        component: OwnerApplicationList
      }
    ]
  },
  {
    path: '/club_application',
    name: 'club_application',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/club_application/:id',
        name: 'club_application_detail',
        component: ClubApplicationData
      },
      {
        path: '/club_application/list',
        name: 'club_application_list',
        component: ClubApplicationList
      }
    ]
  },
  {
    path: '/member',
    name: 'member',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/member/:id',
        name: 'member_detail',
        component: MemberData
      },
      {
        path: '/member/list',
        name: 'member_list',
        component: MemberList
      },
      {
        path: '/member/photo_chk',
        name: 'member_photo_chk',
        component: MemberPhotoChk
      }
    ]
  },
  {
    path: '/club',
    name: 'club',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/club/:id',
        name: 'club_detail',
        component: ClubData
      },
      {
        path: '/club/list',
        name: 'club_list',
        component: ClubList
      }
    ]
  },
  {
    path: '/owner',
    name: 'owner',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/owner/:id',
        name: 'owner_detail',
        component: OwnerData
      },
      {
        path: '/owner/list',
        name: 'owner_list',
        component: OwnerList
      }
    ]
  },
  {
    path: '/system_entry',
    name: 'system_entry',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/system_entry/:id',
        name: 'system_entry_detail',
        component: OwnerEntryData
      },
      {
        path: '/system_entry/list',
        name: 'system_entry_list',
        component: OwnerEntryList
      }
    ]
  },

  {
    path: '/promotion',
    name: 'promotion',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/promotion/ranking',
        name: 'promotion_ranking',
        component: PromotionRanking
      },
      {
        path: '/promotion/:id',
        name: 'promotion_detail',
        component: PromotionData
      },
      {
        path: '/promotion/list',
        name: 'promotion_list',
        component: PromotionList
      }
    ]
  },
  {
    path: '/promotion_cond',
    name: 'promotion_cond',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/promotion_cond/:id',
        name: 'promotion_cond_detail',
        component: PromotionCondData
      },
      {
        path: '/promotion_cond/list',
        name: 'promotion_cond_list',
        component: PromotionCondList
      }
    ]
  },

  {
    path: '/race_series',
    name: 'race_series',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/race_series/:id',
        name: 'race_series_detail',
        component: RaceSeriesData
      },
      {
        path: '/race_series/list',
        name: 'race_series_list',
        component: RaceSeriesList
      }
    ]
  },

  {
    path: '/event_cd',
    name: 'event_cd',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/event_cd/:id',
        name: 'event_cd_detail',
        component: EventCdData
      },
      {
        path: '/event_cd/list',
        name: 'event_cd_list',
        component: EventCdList
      }
    ]
  },
  {
    path: '/race_owner_type_cd',
    name: 'race_owner_type_cd',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/race_owner_type_cd/:id',
        name: 'race_owner_type_cd_detail',
        component: RaceOwnerTypeCdData
      },
      {
        path: '/race_owner_type_cd/list',
        name: 'race_owner_type_cd_list',
        component: RaceOwnerTypeCdList
      }
    ]
  },

  {
    path: '/license_event_cd',
    name: 'license_event_cd',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/license_event_cd/:id',
        name: 'license_event_cd_detail',
        component: LicenseEventCdData
      },
      {
        path: '/license_event_cd/list',
        name: 'license_event_cd_list',
        component: LicenseEventCdList
      }
    ]
  },
  {
    path: '/license_promotion',
    name: 'license_promotion',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/license_promotion/:id',
        name: 'license_promotion_detail',
        component: LicensePromotionData
      }
    ]
  },
  {
    path: '/license_cd',
    name: 'license_cd',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/license_cd/:id',
        name: 'license_cd_detail',
        component: LicenseCdData
      },
      {
        path: '/license_cd/list',
        name: 'license_cd_list',
        component: LicenseCdList
      }
    ]
  },
  {
    path: '/license_type',
    name: 'license_type',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/license_type/:id',
        name: 'license_type_detail',
        component: LicenseTypeData
      },
      {
        path: '/license_type/list',
        name: 'license_type_list',
        component: LicenseTypeList
      }
    ]
  },
  {
    path: '/insurance',
    name: 'insurance',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/insurance/list',
        name: 'insurance_list',
        component: InsuranceList
      }
    ]
  },
  {
    path: '/sales',
    name: 'sales',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/sales/error_check',
        name: 'sales_error_check',
        component: SalesErrorCheck
      },
      {
        path: '/sales/journal',
        name: 'sales_journal',
        component: SalesJournal
      },
      {
        path: '/sales/csv_export',
        name: 'sales_csv_export',
        component: SalesCsvExportView
      },
      {
        path: '/sales/get_payment_log',
        name: 'sales_get_payment_log',
        component: GetPaymentLogView
      },
      {
        path: '/sales/data_list',
        name: 'sales_data_list',
        component: SalesDataList
      }
    ]
  },

  {
    path: '/information',
    name: 'information',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/information/:id',
        name: 'information_detail',
        component: InformationData
      },
      {
        path: '/information/list',
        name: 'information_list',
        component: InformationList
      }
    ]
  },

  {
    path: '/point_block',
    name: 'point_block',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/point_block/:id',
        name: 'point_block_detail',
        component: PointBlockData
      },
      {
        path: '/point_block/list',
        name: 'point_block_list',
        component: PointBlockList
      }
    ]
  },
  {
    path: '/race_class',
    name: 'race_class',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/race_class/:id',
        name: 'race_class_detail',
        component: RaceClassData
      },
      {
        path: '/race_class/list',
        name: 'race_class_list',
        component: RaceClassList
      }
    ]
  },
  {
    path: '/race_type',
    name: 'race_type',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/race_type/:id',
        name: 'race_type_detail',
        component: RaceTypeData
      },
      {
        path: '/race_type/list',
        name: 'race_type_list',
        component: RaceTypeList
      }
    ]
  },
  {
    path: '/area_region',
    name: 'area_region',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/area_region/:id',
        name: 'area_region_detail',
        component: AreaRegionData
      },
      {
        path: '/area_region/list',
        name: 'area_region_list',
        component: AreaRegionList
      }
    ]
  },
  {
    path: '/area_pref',
    name: 'area_pref',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/area_pref/:id',
        name: 'area_pref_detail',
        component: AreaPrefData
      },
      {
        path: '/area_pref/list',
        name: 'area_pref_list',
        component: AreaPrefList
      }
    ]
  },
  {
    path: '/area_district',
    name: 'area_district',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/area_district/:id',
        name: 'area_district_detail',
        component: AreaDistrictData
      },
      {
        path: '/area_district/list',
        name: 'area_district_list',
        component: AreaDistrictList
      }
    ]
  },
  {
    path: '/circuit',
    name: 'circuit',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/circuit/:id',
        name: 'circuit_detail',
        component: CircuitData
      },
      {
        path: '/circuit/list',
        name: 'circuit_list',
        component: CircuitList
      }
    ]
  },
  {
    path: '/migration',
    name: 'migration',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/migration/:id',
        name: 'migration_detail',
        component: MigrationData
      },
      {
        path: '/migration/list',
        name: 'migration_list',
        component: MigrationList
      }
    ]
  },

  {
    path: '/staff',
    name: 'staff',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/staff/:id',
        name: 'staff_detail',
        component: StaffData
      },
      {
        path: '/staff/list',
        name: 'staff_list',
        component: StaffList
      }
    ]
  },
  // {
  //     path: '/clinic',
  //     name: 'clinic',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/clinic/:id',
  //             name: 'clinic_detail',
  //             component: ClinicData,
  //         },
  //         {
  //             path: '/clinic/list',
  //             name: 'clinic_list',
  //             component: ClinicList,
  //         },
  //     ]
  // },
  // {
  //     path: '/personal_type',
  //     name: 'personal_type',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/personal_type/:id',
  //             name: 'personal_type_detail',
  //             component: PersonalTypeData,
  //         },
  //         {
  //             path: '/personal_type/list',
  //             name: 'personal_type_list',
  //             component: PersonalTypeList,
  //         },
  //     ]
  // },
  // {
  //     path: '/photo_type',
  //     name: 'photo_type',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/photo_type/:id',
  //             name: 'photo_type_detail',
  //             component: PhotoTypeData,
  //         },
  //         {
  //             path: '/photo_type/list',
  //             name: 'photo_type_list',
  //             component: PhotoTypeList,
  //         },
  //     ]
  // },
  // {
  //     path: '/process_type',
  //     name: 'process_type',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/process_type/:id',
  //             name: 'process_type_detail',
  //             component: ProcessTypeData,
  //         },
  //         {
  //             path: '/process_type/list',
  //             name: 'process_type_list',
  //             component: ProcessTypeList,
  //         },
  //     ]
  // },
  // {
  //     path: '/process_step',
  //     name: 'process_step',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/process_step/:id',
  //             name: 'process_step_detail',
  //             component: ProcessStepData,
  //         },
  //         {
  //             path: '/process_step/list',
  //             name: 'process_step_list',
  //             component: ProcessStepList,
  //         },
  //     ]
  // },
  // {
  //     path: '/treatment_type',
  //     name: 'treatment_type',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/treatment_type/:id',
  //             name: 'treatment_type_detail',
  //             component: TreatmentTypeData,
  //         },
  //         {
  //             path: '/treatment_type/list',
  //             name: 'treatment_type_list',
  //             component: TreatmentTypeList,
  //         },
  //     ]
  // },

  // {
  //     path: '/estimate_type',
  //     name: 'estimate_type',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/estimate_type/:id',
  //             name: 'estimate_type_detail',
  //             component: EstimateTypeData,
  //         },
  //         {
  //             path: '/estimate_type/list',
  //             name: 'estimate_type_list',
  //             component: EstimateTypeList,
  //         },
  //     ]
  // },
  // {
  //     path: '/estimate_category',
  //     name: 'estimate_category',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/estimate_category/:id',
  //             name: 'estimate_category_detail',
  //             component: EstimateCategoryData,
  //         },
  //         {
  //             path: '/estimate_category/list',
  //             name: 'estimate_category_list',
  //             component: EstimateCategoryList,
  //         },
  //     ]
  // },
  // {
  //     path: '/estimate_sub_category',
  //     name: 'estimate_sub_category',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/estimate_sub_category/:id',
  //             name: 'estimate_sub_category_detail',
  //             component: EstimateSubCategoryData,
  //         },
  //         {
  //             path: '/estimate_sub_category/list',
  //             name: 'estimate_sub_category_list',
  //             component: EstimateSubCategoryList,
  //         },
  //     ]
  // },
  // {
  //     path: '/estimate_subsub_category',
  //     name: 'estimate_subsub_category',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/estimate_subsub_category/:id',
  //             name: 'estimate_subsub_category_detail',
  //             component: EstimateSubSubCategoryData,
  //         },
  //         {
  //             path: '/estimate_subsub_category/list',
  //             name: 'estimate_subsub_category_list',
  //             component: EstimateSubSubCategoryList,
  //         },
  //     ]
  // },

  {
    path: '/manage',
    name: 'manage',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/manage/:id',
        name: 'manage_detail',
        component: ManageData
      },
      {
        path: '/manage/list',
        name: 'manage_list',
        component: ManageList
      },
      {
        path: '/manage/manual',
        name: 'manage_manual',
        component: ManageManual
      }
    ]
  },
  {
    path: '/manage_role',
    name: 'manage_role',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/manage_role/:id',
        name: 'manage_role_detail',
        component: ManageRoleData
      },
      {
        path: '/manage_role/list',
        name: 'manage_role_list',
        component: ManageRoleList
      }
    ]
  },
  // {
  //     path: '/patient',
  //     name: 'patient',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/patient/:id',
  //             name: 'patient_detail',
  //             component: PatientData,
  //         },
  //         {
  //             path: '/patient/list',
  //             name: 'patient_list',
  //             component: PatientList,
  //         },
  //     ]
  // },
  // {
  //     path: '/consulting',
  //     name: 'consulting',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/consulting/:id',
  //             name: 'consulting_detail',
  //             component: ConsultingData,
  //         },
  //         {
  //             path: '/consulting/list',
  //             name: 'consulting_list',
  //             component: ConsultingList,
  //         },
  //         {
  //             path: '/consulting/check',
  //             name: 'consulting_check',
  //             component: ConsultingCheck,
  //         },
  //         {
  //             path: '/consulting/calc',
  //             name: 'consulting_calc',
  //             component: ConsultingCalc,
  //         },
  //         {
  //             path: '/consulting/analysis',
  //             name: 'consulting_analysis',
  //             component: ConsultingAnalysis,
  //         },
  //         {
  //             path: '/consulting/alert',
  //             name: 'consulting_alert',
  //             component: ConsultingAlert,
  //         },
  //     ]
  // },
  // {
  //     path: '/estimate_comment',
  //     name: 'estimate_comment',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/estimate_comment/:id',
  //             name: 'estimate_comment_detail',
  //             component: EstimateCommentData,
  //         },
  //         {
  //             path: '/estimate_comment/list',
  //             name: 'estimate_comment_list',
  //             component: EstimateCommentList,
  //         },
  //     ]
  // },
  // {
  //     path: '/ticket_category',
  //     name: 'ticket_category',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/ticket_category/:id',
  //             name: 'ticket_categoryp_detail',
  //             component: TicketCategoryData,
  //         },
  //         {
  //             path: '/ticket_category/list',
  //             name: 'ticket_category_list',
  //             component: TicketCategoryList,
  //         },
  //     ]
  // },
  // {
  //     path: '/ticket_type',
  //     name: 'ticket_type',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/ticket_type/:id',
  //             name: 'ticket_type_detail',
  //             component: TicketTypeData,
  //         },
  //         {
  //             path: '/ticket_type/list',
  //             name: 'ticket_type_list',
  //             component: TicketTypeList,
  //         },
  //     ]
  // },
  // {
  //     path: '/ticket',
  //     name: 'ticket',
  //     component: TemplateView,
  //     meta: {
  //         requiresAuth: true
  //     },
  //     children: [
  //         {
  //             path: '/ticket/:id',
  //             name: 'ticket_detail',
  //             component: TicketData,
  //         },
  //         {
  //             path: '/ticket/list',
  //             name: 'ticket_list',
  //             component: TicketList,
  //         },
  //     ]
  // },

  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/circuit_chk',
    name: 'circuit_chk',
    component: CircuitChk,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/data/list',
    name: 'DataList',
    component: TemplateView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/error',
    name: 'error',
    component: Logout
  },
  {
    path: '/errors',
    name: 'error',
    component: Error
  },
  {
    path: '/payment_setting',
    name: 'payment_setting',
    component: TemplateView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/payment_setting/:id',
        name: 'payment_setting_detail',
        component: PaymentSettingData
      },
      {
        path: '/payment_setting/list',
        name: 'payment_setting_list',
        component: PaymentSettingList
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: './logout'
  }
]
